import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import DetailsSection from '../common/DetailsSection'
import { useMemberMedicalHistoryConditions } from 'hooks/useMemberMedicalHistoryConditions'
import MedicalHistoryTable from 'components/common/MedicalHistoryTable'

type MedicalAndFamilyHistorySectionProps = {
  // TODO: improve visit type
  visit: any
}

const MedicalAndFamilyHistorySection = ({ visit }: MedicalAndFamilyHistorySectionProps) => {
  const { memberConditions, familyMembersConditions } = useMemberMedicalHistoryConditions(visit)

  const data = useMemo(
    () => [memberConditions, ...familyMembersConditions].filter((item) => !!item.conditions?.length),
    [familyMembersConditions, memberConditions],
  )

  if (!data?.length) {
    return null
  }

  return (
    <DetailsSection title="Medical and Family History">
      <MedicalHistoryTable data={data} />
    </DetailsSection>
  )
}

export default observer(MedicalAndFamilyHistorySection)
